import { IData } from './IData';
import { dataProperties } from './mapperConfig';
import { UtilityService } from '../../../infrastructure/services/utils';

/**
 * provide transformation functionality for data using mapper configuration
 * @param   {Object} documentItem transformed object
 */
export class DataMapper {
  dataItem: IData = {};

  constructor(dataProperty: [] = []) {
    this.dataItem = UtilityService.getMappedProperties(
      dataProperty,
      dataProperties,
      this.dataItem
    );
  }
}
